export default {
  "Content": "_Content_1pwqf_1",
  "GridRow": "_GridRow_1pwqf_6",
  "Header": "_Header_1pwqf_14",
  "Bottom": "_Bottom_1pwqf_22"
};import "ni:sha-256;nRvqKXcDVNQjFwA862JmxaQYdOyylfLxQr_5HhgWyy0";